'use client';
import useAspidaSWR from '@aspida/swr';
import { useContext, useEffect } from 'react';
import { apiClient } from '~/lib/apiClient';
import { isActiveToken } from '~/src/services/users';
import { RootContext } from '~/store';
import { PrizeTicket } from '~/types/resources/prizeTicket';

type UsePrizeTickets = {
  prizeTickets: PrizeTicket[];
  isLoading: boolean;
  error: Error;
  mutate: () => void;
};

/**
 * 当選しているクーポン･チケットを取得する
 *
 * ガチャIDの指定が無い場合は当選している全てのクーポン･チケットを取得する
 *
 * @param {string} [gacha_id] 取得したいガチャのID
 */
export const usePrizeTickets = (gacha_id?: string): UsePrizeTickets => {
  const { token, loggedInState } = useContext(RootContext);

  const { data, error, mutate, isLoading } = useAspidaSWR(
    apiClient.v1.me.prize_tickets,
    {
      headers: {
        Authorization: `Bearer ${token?.token}`,
      },
      query: {
        assigned_gacha_id: gacha_id ?? undefined,
      },
      isPaused: () => !isActiveToken(token) || loggedInState === 'loading',
      dedupingInterval: 1000 * 60 * 60,
      refreshWhenHidden: true,
      revalidateOnMount: true,
    }
  );

  useEffect(() => {
    mutate();
  }, [token]);

  return {
    prizeTickets: data?.prize_tickets ?? [],
    isLoading: isLoading,
    error,
    mutate,
  };
};
